/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} House_Rules_HeadingInputs */

const en_house_rules_heading = /** @type {(inputs: House_Rules_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House Rules`)
};

/**
* | output |
* | --- |
* | "House Rules" |
*
* @param {House_Rules_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const house_rules_heading = /** @type {((inputs?: House_Rules_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<House_Rules_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_house_rules_heading(inputs)
});